import { Col, Divider, Row, Tag, message, Tooltip } from 'antd';
import { useState } from 'react';
import dayjs from 'dayjs';

import EditEntryModal from '../EditEntryModal';
import { airtableURL } from '../../FetchURL';
import http from '../../http-common';
import './index.scss';

const EntryItemPage = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [values, setValues] = useState({
    entryName: props.name,
    entryCategory: props.fullCategory,
    entryPour: props.pour,
    entryBoty: props.boty,
    entryBio: props.description,
    entryStatus: props.status,
  });

  const statusColors = {
    Preparing: 'blue',
    'Waiting for Arrival': 'yellow',
    'Not Received': 'red',
    Judged: 'purple',
    Received: 'green',
  };

  const [loading, setLoading] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onChangeBoty = async (value) => {
    setLoading(true);
    try {
      await http.post(airtableURL + '/update-entry-boty', {
        entryID: props.record,
        entryBoty: value,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error(error.response.data ? error.response.data.error : 'Update Entry Error! Please try again');
      // setErrorMessage("Authentication Failed! Please try again");
    }
  };

  const tooltipText = (status) => {
    switch (status) {
      case 'Preparing':
        return 'Please prepare your entry for shipping.';
      case 'Waiting for Arrival':
        return 'We are waiting for your entry to arrive.';
      case 'Not Received':
        return 'Entry has not been received yet. Please contact us to find out whether you need to reship your entry.';
      case 'Judged':
        return 'Entry has been judged!';
      case 'Received':
        return 'Entry has been received! Thank you for your participation.';
      default:
        return 'Entry status is unknown';
    }
  };

  return (
    <>
      {props.type === 'entry' ? (
        <Row className="w-100 entry-item" justify="space-between">
          <Col span={20}>
            <Row className="w-100" justify="space-between" gutter={[20, 20]}>
              <Col style={{ maxWidth: 250 }}>
                <div>
                  <label className="entry-item__name">{values.entryName}</label>
                </div>
                <div className="d-flex align-center entry-item__component">
                  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.8125 0.75H4.40625C4.32031 0.75 4.25 0.820312 4.25 0.90625V2C4.25 2.08594 4.32031 2.15625 4.40625 2.15625H15.8125C15.8984 2.15625 15.9688 2.08594 15.9688 2V0.90625C15.9688 0.820312 15.8984 0.75 15.8125 0.75ZM15.8125 6.29688H4.40625C4.32031 6.29688 4.25 6.36719 4.25 6.45312V7.54688C4.25 7.63281 4.32031 7.70312 4.40625 7.70312H15.8125C15.8984 7.70312 15.9688 7.63281 15.9688 7.54688V6.45312C15.9688 6.36719 15.8984 6.29688 15.8125 6.29688ZM15.8125 11.8438H4.40625C4.32031 11.8438 4.25 11.9141 4.25 12V13.0938C4.25 13.1797 4.32031 13.25 4.40625 13.25H15.8125C15.8984 13.25 15.9688 13.1797 15.9688 13.0938V12C15.9688 11.9141 15.8984 11.8438 15.8125 11.8438ZM0.03125 1.45312C0.03125 1.59676 0.0595407 1.73899 0.114507 1.87168C0.169473 2.00438 0.250038 2.12496 0.351602 2.22652C0.453166 2.32809 0.57374 2.40865 0.70644 2.46362C0.83914 2.51858 0.981367 2.54688 1.125 2.54688C1.26863 2.54688 1.41086 2.51858 1.54356 2.46362C1.67626 2.40865 1.79683 2.32809 1.8984 2.22652C1.99996 2.12496 2.08053 2.00438 2.13549 1.87168C2.19046 1.73899 2.21875 1.59676 2.21875 1.45312C2.21875 1.30949 2.19046 1.16726 2.13549 1.03457C2.08053 0.901865 1.99996 0.781291 1.8984 0.679727C1.79683 0.578163 1.67626 0.497598 1.54356 0.442632C1.41086 0.387666 1.26863 0.359375 1.125 0.359375C0.981367 0.359375 0.83914 0.387666 0.70644 0.442632C0.57374 0.497598 0.453166 0.578163 0.351602 0.679727C0.250038 0.781291 0.169473 0.901865 0.114507 1.03457C0.0595407 1.16726 0.03125 1.30949 0.03125 1.45312ZM0.03125 7C0.03125 7.14363 0.0595407 7.28586 0.114507 7.41856C0.169473 7.55126 0.250038 7.67183 0.351602 7.7734C0.453166 7.87496 0.57374 7.95553 0.70644 8.01049C0.83914 8.06546 0.981367 8.09375 1.125 8.09375C1.26863 8.09375 1.41086 8.06546 1.54356 8.01049C1.67626 7.95553 1.79683 7.87496 1.8984 7.7734C1.99996 7.67183 2.08053 7.55126 2.13549 7.41856C2.19046 7.28586 2.21875 7.14363 2.21875 7C2.21875 6.85637 2.19046 6.71414 2.13549 6.58144C2.08053 6.44874 1.99996 6.32817 1.8984 6.2266C1.79683 6.12504 1.67626 6.04447 1.54356 5.98951C1.41086 5.93454 1.26863 5.90625 1.125 5.90625C0.981367 5.90625 0.83914 5.93454 0.70644 5.98951C0.57374 6.04447 0.453166 6.12504 0.351602 6.2266C0.250038 6.32817 0.169473 6.44874 0.114507 6.58144C0.0595407 6.71414 0.03125 6.85637 0.03125 7ZM0.03125 12.5469C0.03125 12.6905 0.0595407 12.8327 0.114507 12.9654C0.169473 13.0981 0.250038 13.2187 0.351602 13.3203C0.453166 13.4218 0.57374 13.5024 0.70644 13.5574C0.83914 13.6123 0.981367 13.6406 1.125 13.6406C1.26863 13.6406 1.41086 13.6123 1.54356 13.5574C1.67626 13.5024 1.79683 13.4218 1.8984 13.3203C1.99996 13.2187 2.08053 13.0981 2.13549 12.9654C2.19046 12.8327 2.21875 12.6905 2.21875 12.5469C2.21875 12.4032 2.19046 12.261 2.13549 12.1283C2.08053 11.9956 1.99996 11.875 1.8984 11.7735C1.79683 11.6719 1.67626 11.5913 1.54356 11.5364C1.41086 11.4814 1.26863 11.4531 1.125 11.4531C0.981367 11.4531 0.83914 11.4814 0.70644 11.5364C0.57374 11.5913 0.453166 11.6719 0.351602 11.7735C0.250038 11.875 0.169473 11.9956 0.114507 12.1283C0.0595407 12.261 0.03125 12.4032 0.03125 12.5469Z"
                      fill="#595959"
                    />
                  </svg>
                  <label className="entry-item__label">{values.entryCategory}</label>
                </div>
              </Col>
              <Col>
                <div className="d-flex align-center entry-item__component">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.98828 0.421516C3.67383 0.427376 0.1875 3.91761 0.1875 8.23206C0.1875 10.7321 1.36328 12.9586 3.19141 14.3883L2.45898 15.3258C2.37891 15.4293 2.45313 15.5797 2.58203 15.5778L5.84375 15.5621C5.94531 15.5621 6.01953 15.4664 5.99414 15.3688L5.22266 12.1989C5.21569 12.1703 5.2008 12.1443 5.1797 12.1238C5.15859 12.1033 5.13214 12.0892 5.10337 12.083C5.0746 12.0769 5.04469 12.079 5.01707 12.0892C4.98946 12.0993 4.96526 12.117 4.94727 12.1403L4.15234 13.1578C3.95312 13.0016 3.76172 12.8317 3.58008 12.65C3.00902 12.081 2.55398 11.4063 2.24023 10.6637C1.91406 9.89417 1.75 9.07581 1.75 8.23206C1.75 7.38831 1.91406 6.56995 2.24023 5.80042C2.55469 5.05628 3.00586 4.38831 3.58008 3.81409C4.1543 3.23988 4.82227 2.7887 5.56641 2.47425C6.33789 2.14808 7.15625 1.98402 8 1.98402C8.84375 1.98402 9.66211 2.14808 10.4316 2.47425C11.1758 2.7887 11.8438 3.23988 12.418 3.81409C12.9922 4.38831 13.4434 5.05628 13.7578 5.80042C14.084 6.56995 14.248 7.38831 14.248 8.23206C14.248 9.07581 14.084 9.89417 13.7578 10.6637C13.4441 11.4063 12.989 12.081 12.418 12.65C12.2715 12.7965 12.1191 12.9332 11.9609 13.0641C11.9292 13.0898 11.909 13.1271 11.9046 13.1677C11.9002 13.2083 11.912 13.249 11.9375 13.2809L12.707 14.2672C12.7617 14.3356 12.8613 14.3473 12.9297 14.2926C14.6895 12.859 15.8125 10.6774 15.8125 8.23206C15.8125 3.9137 12.3086 0.415657 7.98828 0.421516Z"
                      fill="#595959"
                    />
                  </svg>
                  <label className="entry-item__label">{values.entryPour}</label>
                </div>
              </Col>
              {/* <Col>
                <div className="d-flex align-center entry-item__component">
                  <Switch onChange={(e) => onChangeBoty(e)} defaultChecked={values.entryBoty} loading={loading} />
                  <label className="entry-item__label">Brewery of the Year</label>
                </div>
              </Col> */}
              <Col>
                <label className="entry-item__description">{values.entryBio}</label>
              </Col>
              <Col>
                <Tooltip title={() => tooltipText(props.status)} color={'geekblue'} key={props.status}>
                  <Tag color={statusColors?.[props.status]}>{props.status}</Tag>
                </Tooltip>
              </Col>
            </Row>
          </Col>

          {dayjs().isBefore(dayjs(props.editEnd)) ? (
            <Col span={4} className="d-flex justify-end ">
              <Divider type="vertical" className="entry-item__divider" />

              <Col className="d-flex align-center ">
                <div style={{ margin: '0 10px' }} onClick={showModal}>
                  <svg
                    className="pointer"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.03984 15.625C4.08672 15.625 4.13359 15.6203 4.18047 15.6133L8.12266 14.9219C8.16953 14.9125 8.21406 14.8914 8.24688 14.8563L18.182 4.92109C18.2038 4.89941 18.221 4.87366 18.2328 4.8453C18.2445 4.81695 18.2506 4.78656 18.2506 4.75586C18.2506 4.72516 18.2445 4.69477 18.2328 4.66642C18.221 4.63806 18.2038 4.61231 18.182 4.59063L14.2867 0.692969C14.2422 0.648438 14.1836 0.625 14.1203 0.625C14.057 0.625 13.9984 0.648438 13.9539 0.692969L4.01875 10.6281C3.98359 10.6633 3.9625 10.7055 3.95312 10.7523L3.26172 14.6945C3.23892 14.8201 3.24707 14.9493 3.28545 15.071C3.32384 15.1927 3.39132 15.3032 3.48203 15.393C3.63672 15.543 3.83125 15.625 4.03984 15.625ZM5.61953 11.5375L14.1203 3.03906L15.8383 4.75703L7.3375 13.2555L5.25391 13.6234L5.61953 11.5375ZM18.625 17.5938H1.375C0.960156 17.5938 0.625 17.9289 0.625 18.3438V19.1875C0.625 19.2906 0.709375 19.375 0.8125 19.375H19.1875C19.2906 19.375 19.375 19.2906 19.375 19.1875V18.3438C19.375 17.9289 19.0398 17.5938 18.625 17.5938Z"
                      fill="#8C8C8C"
                    />
                  </svg>
                </div>
              </Col>
            </Col>
          ) : null}
        </Row>
      ) : (
        <div key={props.record}>
          <Row>
            <Col span={9} style={{ padding: '1%' }}>
              <div>
                <label className="shopping-cart__name">{values.entryName}</label>
              </div>
              <div className="d-flex align-center shopping-cart__component">
                <label className="shopping-cart__label">{values.entryCategory}</label>
              </div>
            </Col>

            <Col span={6} style={{ padding: '1%' }}>
              <div className="d-flex align-center shopping-cart__component">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.98828 0.421516C3.67383 0.427376 0.1875 3.91761 0.1875 8.23206C0.1875 10.7321 1.36328 12.9586 3.19141 14.3883L2.45898 15.3258C2.37891 15.4293 2.45313 15.5797 2.58203 15.5778L5.84375 15.5621C5.94531 15.5621 6.01953 15.4664 5.99414 15.3688L5.22266 12.1989C5.21569 12.1703 5.2008 12.1443 5.1797 12.1238C5.15859 12.1033 5.13214 12.0892 5.10337 12.083C5.0746 12.0769 5.04469 12.079 5.01707 12.0892C4.98946 12.0993 4.96526 12.117 4.94727 12.1403L4.15234 13.1578C3.95312 13.0016 3.76172 12.8317 3.58008 12.65C3.00902 12.081 2.55398 11.4063 2.24023 10.6637C1.91406 9.89417 1.75 9.07581 1.75 8.23206C1.75 7.38831 1.91406 6.56995 2.24023 5.80042C2.55469 5.05628 3.00586 4.38831 3.58008 3.81409C4.1543 3.23988 4.82227 2.7887 5.56641 2.47425C6.33789 2.14808 7.15625 1.98402 8 1.98402C8.84375 1.98402 9.66211 2.14808 10.4316 2.47425C11.1758 2.7887 11.8438 3.23988 12.418 3.81409C12.9922 4.38831 13.4434 5.05628 13.7578 5.80042C14.084 6.56995 14.248 7.38831 14.248 8.23206C14.248 9.07581 14.084 9.89417 13.7578 10.6637C13.4441 11.4063 12.989 12.081 12.418 12.65C12.2715 12.7965 12.1191 12.9332 11.9609 13.0641C11.9292 13.0898 11.909 13.1271 11.9046 13.1677C11.9002 13.2083 11.912 13.249 11.9375 13.2809L12.707 14.2672C12.7617 14.3356 12.8613 14.3473 12.9297 14.2926C14.6895 12.859 15.8125 10.6774 15.8125 8.23206C15.8125 3.9137 12.3086 0.415657 7.98828 0.421516Z"
                    fill="#595959"
                  />
                </svg>
                <label className="shopping-cart__label">{values.entryPour}</label>
              </div>
              <br />
              {/* <div className="d-flex align-center shopping-cart__component">
                <Switch onChange={(e) => onChangeBoty(e)} defaultChecked={values.entryBoty} loading={loading} />
                <label className="shopping-cart__label">Brewery of the Year</label>
              </div> */}
            </Col>
            <Col span={6} style={{ padding: '1%' }}>
              <label className="shopping-cart__description">{values.entryBio}</label>
            </Col>
            <Col span={3} className="text-center" style={{ padding: '1%' }}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="pointer"
                style={{ marginRight: '20px' }}
                onClick={showModal}
              >
                <path
                  d="M4.03984 15.625C4.08672 15.625 4.13359 15.6203 4.18047 15.6133L8.12266 14.9219C8.16953 14.9125 8.21406 14.8914 8.24688 14.8563L18.182 4.92109C18.2038 4.89941 18.221 4.87366 18.2328 4.8453C18.2445 4.81695 18.2506 4.78656 18.2506 4.75586C18.2506 4.72516 18.2445 4.69477 18.2328 4.66642C18.221 4.63806 18.2038 4.61231 18.182 4.59063L14.2867 0.692969C14.2422 0.648438 14.1836 0.625 14.1203 0.625C14.057 0.625 13.9984 0.648438 13.9539 0.692969L4.01875 10.6281C3.98359 10.6633 3.9625 10.7055 3.95312 10.7523L3.26172 14.6945C3.23892 14.8201 3.24707 14.9493 3.28545 15.071C3.32384 15.1927 3.39132 15.3032 3.48203 15.393C3.63672 15.543 3.83125 15.625 4.03984 15.625ZM5.61953 11.5375L14.1203 3.03906L15.8383 4.75703L7.3375 13.2555L5.25391 13.6234L5.61953 11.5375ZM18.625 17.5938H1.375C0.960156 17.5938 0.625 17.9289 0.625 18.3438V19.1875C0.625 19.2906 0.709375 19.375 0.8125 19.375H19.1875C19.2906 19.375 19.375 19.2906 19.375 19.1875V18.3438C19.375 17.9289 19.0398 17.5938 18.625 17.5938Z"
                  fill="#595959"
                />
              </svg>

              <svg
                width="18"
                height="20"
                viewBox="0 0 18 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="pointer"
                onClick={props.onDelete}
              >
                <path
                  d="M5.4375 2.3125H5.25C5.35313 2.3125 5.4375 2.22812 5.4375 2.125V2.3125H12.5625V2.125C12.5625 2.22812 12.6469 2.3125 12.75 2.3125H12.5625V4H14.25V2.125C14.25 1.29766 13.5773 0.625 12.75 0.625H5.25C4.42266 0.625 3.75 1.29766 3.75 2.125V4H5.4375V2.3125ZM17.25 4H0.75C0.335156 4 0 4.33516 0 4.75V5.5C0 5.60313 0.084375 5.6875 0.1875 5.6875H1.60312L2.18203 17.9453C2.21953 18.7445 2.88047 19.375 3.67969 19.375H14.3203C15.1219 19.375 15.7805 18.7469 15.818 17.9453L16.3969 5.6875H17.8125C17.9156 5.6875 18 5.60313 18 5.5V4.75C18 4.33516 17.6648 4 17.25 4ZM14.1398 17.6875H3.86016L3.29297 5.6875H14.707L14.1398 17.6875Z"
                  fill="#FF4D4F"
                />
              </svg>
            </Col>
            {/* <Col span={3} className="text-right">
              <label className="shopping-cart__each-price">${props.price}</label>
            </Col> */}
          </Row>
          <Divider className="shopping-cart__divider" />
        </div>
      )}

      {isModalOpen && (
        <EditEntryModal
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          name={props.name}
          entryCategory={props.fullCategory}
          entryCategoryValue={props.fullCategoryValue}
          entryPour={props.pour}
          entryBio={props.description}
          entryBoty={props.boty}
          record={props.record}
          categories={props.categories}
          setEntryValues={setValues}
          fetchShoppingData={props.fetchShoppingData}
          updateShoppingData={props.updateShoppingData}
        />
      )}
    </>
  );
};

export default EntryItemPage;
